// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Semi Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Regular Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Medium Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Bold Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-display: swap;
}
.vrise-active-status {
  color: var(--accent-exceptional-primary-blue-color);
  background: var(--accent-tertiary-blue-color);
}

.vrise-green {
  border: 0.5px solid var(--accent-primary-dark-green-color);
  background: var(--accent-secondary-dark-green-color);
  color: var(--accent-primary-dark-green-color);
}

.vrise-red {
  border: 0.5px solid var(--accent-primary-red-color);
  background: var(--accent-secondary-red-color);
  color: var(--accent-primary-red-color);
}

.vrise-yellow {
  border-radius: 8px;
  border: 0.5px solid var(--accent-primary-yellow-color);
  background: var(--accent-tertiary-yellow-color);
  color: var(--accent-primary-yellow-color);
}

.vrise-grey {
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--quartinary-surface-color);
  color: var(--primary-text-color);
}

.vrise-container {
  display: flex;
}
.vrise-job-section {
  background-color: var(--main-surface-color);
  display: flex;
  padding: 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 28px;
  height: calc(100vh - 90px);
  scrollbar-width: none;
  width: 72.5%;
}
@media (max-width: 1023px) {
  .vrise-job-section {
    width: 100%;
  }
}
@media (max-width: 650px) {
  .vrise-job-section {
    padding: 20px 10px 10px;
  }
}
.vrise-tabs {
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  box-shadow: 0px 0px 20px 0px rgba(51, 59, 72, 0.05);
}
.vrise-tab {
  display: flex;
  padding: 16px 24px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  border-right: 1px solid var(--border-color);
}
.vrise-tab-status {
  color: var(--tertiary-text-color);
}
.vrise-tab-count {
  color: var(--tertiary-text-color);
}
.vrise-job-view-header {
  display: flex;
  padding: 0px 24px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  border-bottom: 1px solid var(--border-color);
  background: var(--vrise-job-card-bg-color);
}
.vrise-experiment {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 8px;
  position: sticky;
  top: 0px;
  width: 100%;
  background: var(--vrise-job-card-bg-color);
}
.vrise-resume-container {
  display: flex;
  align-items: flex-start;
  gap: 28px;
  align-self: stretch;
}
.vrise-resume-cards {
  display: flex;
  width: 380px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  scrollbar-width: none;
}
@media (max-width: 1023px) {
  .vrise-resume-cards {
    width: 100%;
  }
}
.vrise-job-view {
  display: flex;
  height: calc(100vh - 210px);
  flex-direction: column;
  align-items: flex-start;
  scrollbar-width: none;
  flex: 1 0 0;
  border-radius: 20px;
  overflow-y: auto;
  border: 1px solid var(--border-color);
  background: var(--primary-surface-color);
}
@media (max-width: 1023px) {
  .vrise-job-view {
    display: none;
  }
}
.vrise-job-view-description {
  display: flex;
  padding: 20px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}
.vrise-job-about {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}
.vrise-job-about-title {
  color: var(--tertiary-text-color);
  /* New Typeface/Heading 4 */
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%; /* 24px */
}
.vrise-job-about-description {
  color: var(--secondary-text-color);
  font-family: "Regular Sans", sans-serif;
  font-style: normal;
  font-size: 14px;
  line-height: 150%; /* 21px */
}
.vrise-job-view-header-cta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
}
.vrise-job-view-header-cta-applynow {
  display: flex;
  padding: 12px 32px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: var(--accent-primary-blue-color);
  color: var(--primary-surface-color);
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%; /* 14px */
}
@media (max-width: 1280px) {
  .vrise-job-view-header-cta-applynow {
    padding: 12px;
  }
}
.vrise-job-view-header-cta-jd {
  display: flex;
  padding: 12px 32px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid var(--accent-primary-blue-color);
  background: var(--primary-surface-color);
  color: var(--accent-primary-blue-color);
  text-decoration: none;
  /* New Typeface/CTA secondary */
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%; /* 14px */
}
@media (max-width: 650px) {
  .vrise-job-view-header-cta-jd {
    padding: 12px;
  }
}
.vrise-job-view-header-tagline {
  display: flex;
  padding: 8px;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 6px;
  border: 1px solid var(--border-color);
  background: var(--secondary-surface-color);
}
.vrise-job-view-header-tagline-text {
  color: var(--secondary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%; /* 14px */
}
.vrise-job-view-header-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}
.vrise-job-view-header-info-details {
  color: var(--secondary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%; /* 14px */
}
.vrise-job-view-header-info-jobtitle {
  color: var(--tertiary-text-color);
  /* New Typeface/Sub Heading 2 */
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 125%; /* 20px */
}
.vrise-job-view-header-info-company {
  color: var(--primary-text-color);
  /* New Typeface/Sub Heading 2 */
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 125%; /* 20px */
}

.vrise-user-profile-section {
  display: flex;
  padding: 28px;
  width: 27.5%;
  overflow-y: auto;
  flex-direction: column;
  height: calc(100vh - 90px);
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
  border-left: 1px solid var(--border-color);
  background: var(--primary-surface-color);
  box-shadow: 0px 0px 10px 0px rgba(51, 59, 72, 0.05);
  scrollbar-width: none;
}
@media (max-width: 1023px) {
  .vrise-user-profile-section {
    display: none;
  }
}
.vrise-user-profile-container {
  display: flex;
  width: 95%;
  padding: 20px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 20px;
  border: 1px solid var(--border-color);
}
.vrise-user-profile-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
}
.vrise-user-profile-name {
  color: var(--primary-text-color);
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%; /* 16px */
}
.vrise-user-profile-resume-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.vrise-user-profile-status {
  color: var(--secondary-text-color);
  text-align: center;
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%; /* 14px */
}
.vrise-user-profile-tags {
  display: flex;
  padding: 6px 12px 6px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  gap: 4px;
  font-family: "Medium Sans";
  font-size: 14px;
  line-height: 140%;
  white-space: nowrap;
}
.vrise-user-profile-update {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}
.vrise-user-profile-update-btn {
  display: flex;
  height: 36px;
  padding: 0px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--accent-primary-blue-color);
  color: var(--accent-primary-blue-color);
  text-align: center;
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 125%; /* 17.5px */
}
.vrise-user-profile-progress {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}
.vrise-user-profile-completed {
  color: var(--secondary-text-color);
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  font-style: normal;
  line-height: 100%; /* 14px */
}
.vrise-user-profile-updated-time {
  color: var(--tertiary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 150%; /* 19.5px */
}

.progress-bar-colored {
  background-color: #f5f7fb;
  border-radius: 10px;
  height: 12px;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  border-radius: 10px;
  transition: width 0.3s ease;
  position: relative;
  z-index: 2;
  height: 12px;
}

.placement-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 20px;
  border: 1px solid var(--border-color);
  overflow-y: auto;
  scrollbar-width: none;
}

.placement-news {
  display: flex;
  padding: 12px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-bottom: 2px dashed var(--border-color);
  background: var(--primary-surface-color);
  background-image: url("https://staging.herovired.com/wp-content/uploads/2025/03/celebration_bg.png");
}

.placement-news:last-child {
  border-bottom: none;
}

.placement-news-date {
  color: var(--quartinary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 125%; /* 15px */
}

.placement-news-name {
  color: var(--secondary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 125%; /* 17.5px */
}

.empty-container {
  display: flex;
  padding: 16px 16px 20px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 20px;
  border: 2px solid var(--border-color);
  background: var(--primary-surface-color);
}

.empty-container-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 18px;
}

.empty-container-text {
  color: var(--quinary-text-color);
  text-align: center;
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 150%; /* 27px */
}

.sticky-header-vrise {
  position: sticky;
  top: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/pages/VRise/style.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACAF;ADGA;EACE,2BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACFF;ADIA;EACE,0BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACHF;ADKA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACJF;AArBA;EACI,mDAAA;EACA,6CAAA;AAuBJ;;AApBA;EACI,0DAAA;EACA,oDAAA;EACA,6CAAA;AAuBJ;;AApBA;EACI,mDAAA;EACA,6CAAA;EACA,sCAAA;AAuBJ;;AApBA;EACI,kBAAA;EACA,sDAAA;EACA,+CAAA;EACA,yCAAA;AAuBJ;;AApBA;EACI,kBAAA;EACA,qCAAA;EACA,2CAAA;EACA,gCAAA;AAuBJ;;AAnBI;EACI,aAAA;AAsBR;AApBI;EACI,2CAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,0BAAA;EACA,qBAAA;EACA,YAAA;AAsBR;ACkCE;EDjEE;IAWQ,WAAA;EAwBV;AACF;AC6BE;EDjEE;IAcQ,uBAAA;EA0BV;AACF;AAxBI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,mDAAA;AA0BR;AAvBI;EACI,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,2CAAA;AAyBR;AAtBI;EACI,iCAAA;AAwBR;AArBI;EACI,iCAAA;AAuBR;AApBI;EACI,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EAEA,4CAAA;EACA,0CAAA;AAqBR;AAlBI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;EACA,QAAA;EACA,WAAA;EACA,0CAAA;AAoBR;AAjBI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAmBR;AAjBI;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,qBAAA;AAmBR;ACjCE;EDQE;IAQQ,WAAA;EAqBV;AACF;AAlBI;EACI,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;EACA,wCAAA;AAoBR;AClDE;EDoBE;IAYQ,aAAA;EAsBV;AACF;AApBI;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAsBR;AApBI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AAsBR;AApBI;EACI,iCAAA;EAEA,2BAAA;ECjHN,oCAAA;EACA,kBAAA;EACA,gBAAA;EDiHM,eAAA;EACA,iBAAA,EAAA,SAAA;AAuBR;AArBI;EACI,kCAAA;EChIN,uCAAA;EACA,kBAAA;EDiIM,eAAA;EACA,iBAAA,EAAA,SAAA;AAwBR;AAtBI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAwBR;AAtBI;EACI,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,4CAAA;EACA,mCAAA;EC3IN,oCAAA;EACA,kBAAA;EACA,gBAAA;ED2IM,eAAA;EACA,iBAAA,EAAA,SAAA;AA0BR;AC5GE;EDuEE;IAaQ,aAAA;EA4BV;AACF;AA1BI;EACI,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kDAAA;EACA,wCAAA;EACA,uCAAA;EACA,qBAAA;EACA,+BAAA;EC9JN,oCAAA;EACA,kBAAA;EACA,gBAAA;ED8JM,eAAA;EACA,iBAAA,EAAA,SAAA;AA8BR;ACnIE;EDuFE;IAgBQ,aAAA;EAgCV;AACF;AA9BI;EACI,aAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,0CAAA;AAgCR;AA9BI;EACI,kCAAA;ECvLN,sCAAA;EACA,kBAAA;EACA,gBAAA;EDuLM,eAAA;EACA,iBAAA,EAAA,SAAA;AAkCR;AAhCI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAkCR;AAhCI;EACI,kCAAA;ECpMN,sCAAA;EACA,kBAAA;EACA,gBAAA;EDoMM,eAAA;EACA,iBAAA,EAAA,SAAA;AAoCR;AAlCI;EACI,iCAAA;EAEA,+BAAA;EC5MN,sCAAA;EACA,kBAAA;EACA,gBAAA;ED4MM,eAAA;EACA,iBAAA,EAAA,SAAA;AAqCR;AAnCI;EACI,gCAAA;EACA,+BAAA;EC9MN,oCAAA;EACA,kBAAA;EACA,gBAAA;ED8MM,eAAA;EACA,iBAAA,EAAA,SAAA;AAuCR;;AAlCI;EACI,aAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,0CAAA;EACA,wCAAA;EACA,mDAAA;EACA,qBAAA;AAqCR;AC5ME;ED0JE;IAeQ,aAAA;EAuCV;AACF;AArCI;EACI,aAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;AAuCR;AArCI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAuCR;AArCI;EACI,gCAAA;EC3PN,oCAAA;EACA,kBAAA;EACA,gBAAA;ED2PM,eAAA;EACA,iBAAA,EAAA,SAAA;AAyCR;AAvCI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAyCR;AAvCI;EACI,kCAAA;EACA,kBAAA;ECxQN,oCAAA;EACA,kBAAA;EACA,gBAAA;EDwQM,eAAA;EACA,iBAAA,EAAA,SAAA;AA2CR;AAzCI;EACI,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AA2CR;AAzCI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AA2CR;AAzCI;EACI,aAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,kDAAA;EACA,uCAAA;EACA,kBAAA;EC5SN,oCAAA;EACA,kBAAA;EACA,gBAAA;ED4SM,eAAA;EACA,iBAAA,EAAA,WAAA;AA6CR;AA3CI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AA6CR;AA3CI;EACI,kCAAA;ECzTN,oCAAA;EACA,kBAAA;EACA,gBAAA;EDyTM,eAAA;EACA,kBAAA;EACA,iBAAA,EAAA,SAAA;AA+CR;AA7CI;EACI,iCAAA;ECrUN,sCAAA;EACA,kBAAA;EACA,gBAAA;EDqUM,eAAA;EACA,iBAAA,EAAA,WAAA;AAiDR;;AA7CA;EACI,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAgDJ;;AA7CA;EACI,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAgDJ;;AA7CA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,gBAAA;EACA,qBAAA;AAgDJ;;AA9CA;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,6CAAA;EACA,wCAAA;EACA,oGAAA;AAiDJ;;AA9CA;EACI,mBAAA;AAiDJ;;AA9CA;EACI,mCAAA;ECzXF,sCAAA;EACA,kBAAA;EACA,gBAAA;EDyXE,eAAA;EACA,iBAAA,EAAA,SAAA;AAmDJ;;AAjDA;EACI,kCAAA;EC/XF,sCAAA;EACA,kBAAA;EACA,gBAAA;ED+XE,eAAA;EACA,iBAAA,EAAA,WAAA;AAsDJ;;AAnDA;EACI,aAAA;EACA,4BAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,wCAAA;AAsDJ;;AAnDA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAsDJ;;AAnDA;EACI,gCAAA;EACA,kBAAA;EC7ZF,sCAAA;EACA,kBAAA;EACA,gBAAA;ED6ZE,eAAA;EACA,iBAAA,EAAA,SAAA;AAwDJ;;AArDA;EACI,gBAAA;EACA,MAAA;AAwDJ","sourcesContent":["@font-face {\n  font-family: 'Semi Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf')\n    format('truetype');\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Regular Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Medium Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Bold Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf')\n    format('truetype');\n  font-display: swap;\n}\n","@import \"../../styles/styles.scss\";\n\n.vrise-active-status {\n    color: var(--accent-exceptional-primary-blue-color);\n    background: var(--accent-tertiary-blue-color);\n}\n\n.vrise-green {\n    border: 0.5px solid var(--accent-primary-dark-green-color);\n    background: var(--accent-secondary-dark-green-color);\n    color: var(--accent-primary-dark-green-color);\n}\n\n.vrise-red {\n    border: 0.5px solid var(--accent-primary-red-color);\n    background: var(--accent-secondary-red-color);\n    color: var(--accent-primary-red-color);\n}\n\n.vrise-yellow {\n    border-radius: 8px;\n    border: 0.5px solid var(--accent-primary-yellow-color);\n    background: var(--accent-tertiary-yellow-color);\n    color: var(--accent-primary-yellow-color);\n}\n\n.vrise-grey {\n    border-radius: 8px;\n    border: 1px solid var(--border-color);\n    background: var(--quartinary-surface-color);\n    color: var(--primary-text-color);\n}\n\n.vrise {\n    &-container {\n        display: flex;\n    }\n    &-job-section {\n        background-color: var(--main-surface-color);\n        display: flex;\n        padding: 32px;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 28px;\n        height: calc(100vh - 90px);\n        scrollbar-width: none;\n        width: 72.5%;\n        @include respond-to(1023px) {\n            width: 100%;\n        }\n        @include respond-to(650px) {\n            padding: 20px 10px 10px;\n        }\n    }\n    &-tabs {\n        display: flex;\n        align-items: flex-start;\n        align-self: stretch;\n        border-radius: 8px;\n        border: 1px solid var(--border-color);\n        box-shadow: 0px 0px 20px 0px rgba(51, 59, 72, 0.05);\n    }\n\n    &-tab {\n        display: flex;\n        padding: 16px 24px;\n        justify-content: space-between;\n        align-items: center;\n        flex: 1 0 0;\n        border-right: 1px solid var(--border-color);\n    }\n\n    &-tab-status {\n        color: var(--tertiary-text-color);\n    }\n\n    &-tab-count {\n        color: var(--tertiary-text-color);\n    }\n\n    &-job-view-header {\n        display: flex;\n        padding: 0px 24px 24px;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 20px;\n        align-self: stretch;\n        // border-radius: 20px 20px 0px 0px;\n        border-bottom: 1px solid var(--border-color);\n        background: var(--vrise-job-card-bg-color);\n    }\n\n    &-experiment {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        padding: 24px;\n        gap: 8px;\n        position: sticky;\n        top: 0px;\n        width: 100%;\n        background: var(--vrise-job-card-bg-color);\n    }\n\n    &-resume-container {\n        display: flex;\n        align-items: flex-start;\n        gap: 28px;\n        align-self: stretch;\n    }\n    &-resume-cards {\n        display: flex;\n        width: 380px;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 16px;\n        scrollbar-width: none;\n        @include respond-to(1023px) {\n            width: 100%;\n        }\n    }\n\n    &-job-view {\n        display: flex;\n        height: calc(100vh - 210px);\n        flex-direction: column;\n        align-items: flex-start;\n        scrollbar-width: none;\n        flex: 1 0 0;\n        border-radius: 20px;\n        overflow-y: auto;\n        border: 1px solid var(--border-color);\n        background: var(--primary-surface-color);\n        @include respond-to(1023px) {\n            display: none;\n        }\n    }\n    &-job-view-description {\n        display: flex;\n        padding: 20px 24px;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 20px;\n        align-self: stretch;\n    }\n    &-job-about {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n        align-self: stretch;\n    }\n    &-job-about-title {\n        color: var(--tertiary-text-color);\n\n        /* New Typeface/Heading 4 */\n        @include SemiSans;\n        font-size: 16px;\n        line-height: 150%; /* 24px */\n    }\n    &-job-about-description {\n        color: var(--secondary-text-color);\n        @include RegularSans;\n        font-size: 14px;\n        line-height: 150%; /* 21px */\n    }\n    &-job-view-header-cta {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n        align-self: stretch;\n    }\n    &-job-view-header-cta-applynow {\n        display: flex;\n        padding: 12px 32px;\n        justify-content: center;\n        align-items: center;\n        gap: 8px;\n        border-radius: 8px;\n        background: var(--accent-primary-blue-color);\n        color: var(--primary-surface-color);\n        @include SemiSans;\n        font-size: 14px;\n        line-height: 100%; /* 14px */\n        @include respond-to(1280px) {\n            padding: 12px;\n        }\n    }\n    &-job-view-header-cta-jd {\n        display: flex;\n        padding: 12px 32px;\n        justify-content: center;\n        align-items: center;\n        gap: 8px;\n        border-radius: 8px;\n        border: 1px solid var(--accent-primary-blue-color);\n        background: var(--primary-surface-color);\n        color: var(--accent-primary-blue-color);\n        text-decoration: none;\n        /* New Typeface/CTA secondary */\n        @include SemiSans;\n        font-size: 14px;\n        line-height: 100%; /* 14px */\n        @include respond-to(650px) {\n            padding: 12px;\n        }\n    }\n    &-job-view-header-tagline {\n        display: flex;\n        padding: 8px;\n        justify-content: flex-start;\n        align-items: center;\n        gap: 4px;\n        align-self: stretch;\n        border-radius: 6px;\n        border: 1px solid var(--border-color);\n        background: var(--secondary-surface-color);\n    }\n    &-job-view-header-tagline-text {\n        color: var(--secondary-text-color);\n        @include MediumSans;\n        font-size: 14px;\n        line-height: 100%; /* 14px */\n    }\n    &-job-view-header-info {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 16px;\n        align-self: stretch;\n    }\n    &-job-view-header-info-details {\n        color: var(--secondary-text-color);\n        @include MediumSans;\n        font-size: 14px;\n        line-height: 100%; /* 14px */\n    }\n    &-job-view-header-info-jobtitle {\n        color: var(--tertiary-text-color);\n\n        /* New Typeface/Sub Heading 2 */\n        @include MediumSans;\n        font-size: 16px;\n        line-height: 125%; /* 20px */\n    }\n    &-job-view-header-info-company {\n        color: var(--primary-text-color);\n        /* New Typeface/Sub Heading 2 */\n        @include SemiSans;\n        font-size: 20px;\n        line-height: 125%; /* 20px */\n    }\n}\n\n.vrise-user-profile {\n    &-section {\n        display: flex;\n        padding: 28px;\n        width: 27.5%;\n        overflow-y: auto;\n        flex-direction: column;\n        height: calc(100vh - 90px);\n        align-items: center;\n        gap: 24px;\n        flex-shrink: 0;\n        border-left: 1px solid var(--border-color);\n        background: var(--primary-surface-color);\n        box-shadow: 0px 0px 10px 0px rgba(51, 59, 72, 0.05);\n        scrollbar-width: none;\n        @include respond-to(1023px) {\n            display: none;\n        }\n    }\n    &-container {\n        display: flex;\n        width: 95%;\n        padding: 20px;\n        flex-direction: column;\n        align-items: center;\n        gap: 12px;\n        align-self: stretch;\n        border-radius: 20px;\n        border: 1px solid var(--border-color);\n    }\n    &-data {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 8px;\n        align-self: stretch;\n    }\n    &-name {\n        color: var(--primary-text-color);\n        @include SemiSans;\n        font-size: 16px;\n        line-height: 100%; /* 16px */\n    }\n    &-resume-status {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        align-self: stretch;\n    }\n    &-status {\n        color: var(--secondary-text-color);\n        text-align: center;\n        @include SemiSans;\n        font-size: 14px;\n        line-height: 100%; /* 14px */\n    }\n    &-tags {\n        display: flex;\n        padding: 6px 12px 6px 10px;\n        justify-content: center;\n        align-items: center;\n        border-radius: 24px;\n        gap: 4px;\n        font-family: \"Medium Sans\";\n        font-size: 14px;\n        line-height: 140%;\n        white-space: nowrap;\n    }\n    &-update {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: flex-start;\n        gap: 16px;\n        align-self: stretch;\n    }\n    &-update-btn {\n        display: flex;\n        height: 36px;\n        padding: 0px 24px;\n        justify-content: center;\n        align-items: center;\n        gap: 8px;\n        align-self: stretch;\n        border-radius: 8px;\n        border: 1px solid var(--accent-primary-blue-color);\n        color: var(--accent-primary-blue-color);\n        text-align: center;\n        @include SemiSans;\n        font-size: 14px;\n        line-height: 125%; /* 17.5px */\n    }\n    &-progress {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n        align-self: stretch;\n    }\n    &-completed {\n        color: var(--secondary-text-color);\n        @include SemiSans;\n        font-size: 14px;\n        font-style: normal;\n        line-height: 100%; /* 14px */\n    }\n    &-updated-time {\n        color: var(--tertiary-text-color);\n        @include MediumSans;\n        font-size: 13px;\n        line-height: 150%; /* 19.5px */\n    }\n}\n\n.progress-bar-colored {\n    background-color: #f5f7fb;\n    border-radius: 10px;\n    height: 12px;\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n}\n\n.progress-bar-fill {\n    height: 100%;\n    border-radius: 10px;\n    transition: width 0.3s ease;\n    position: relative;\n    z-index: 2;\n    height: 12px;\n}\n\n.placement-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    align-self: stretch;\n    border-radius: 20px;\n    border: 1px solid var(--border-color);\n    overflow-y: auto;\n    scrollbar-width: none;\n}\n.placement-news {\n    display: flex;\n    padding: 12px 20px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    align-self: stretch;\n    border-bottom: 2px dashed var(--border-color);\n    background: var(--primary-surface-color);\n    background-image: url(\"https://staging.herovired.com/wp-content/uploads/2025/03/celebration_bg.png\");\n}\n\n.placement-news:last-child {\n    border-bottom: none;\n}\n\n.placement-news-date {\n    color: var(--quartinary-text-color);\n    @include MediumSans;\n    font-size: 12px;\n    line-height: 125%; /* 15px */\n}\n.placement-news-name {\n    color: var(--secondary-text-color);\n    @include MediumSans;\n    font-size: 14px;\n    line-height: 125%; /* 17.5px */\n}\n\n.empty-container {\n    display: flex;\n    padding: 16px 16px 20px 16px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 16px;\n    flex: 1 0 0;\n    align-self: stretch;\n    border-radius: 20px;\n    border: 2px solid var(--border-color);\n    background: var(--primary-surface-color);\n}\n\n.empty-container-section {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 18px;\n}\n\n.empty-container-text {\n    color: var(--quinary-text-color);\n    text-align: center;\n    @include MediumSans;\n    font-size: 18px;\n    line-height: 150%; /* 27px */\n}\n\n.sticky-header-vrise {\n    position: sticky;\n    top: 0;\n}\n","@mixin flex($direction: row, $align-items: center, $justify-content: center) {\n  display: flex;\n  flex-direction: $direction;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n@mixin container {\n  margin: auto;\n  max-width: 1920px;\n}\n\n@mixin s_container {\n  max-width: 1536px;\n  margin: 0 auto;\n  padding: 0 32px;\n\n  @include l_desktop {\n    max-width: 1320px;\n  }\n\n  @include s_tablet {\n    padding: 0 16px;\n  }\n}\n\n@mixin box($width, $height: $width) {\n  width: $width;\n  height: $height;\n}\n\n// FONT ISSUE NOT MATCHING NEED TO GRAB NEW FONTS\n@mixin RegularSans {\n  font-family: 'Regular Sans', sans-serif;\n  font-style: normal;\n}\n@mixin MediumSans {\n  font-family: 'Medium Sans', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n}\n@mixin SemiSans {\n  font-family: 'Semi Sans', sans-serif;\n  font-style: normal;\n  font-weight: 600;\n}\n@mixin BoldSans {\n  font-family: 'Bold Sans', sans-serif;\n  font-style: normal;\n  font-weight: 700;\n}\n@mixin IBMPlexMonoMedium {\n  font-family: 'IBM Plex Mono', monospace;\n  font-weight: 500;\n  font-style: normal;\n}\n\n\n@mixin auth-heading {\n  @include Playfair;\n  line-height: 1.875rem;\n  font-weight: 600;\n  letter-spacing: -3%;\n  font-size: 2rem;\n  @include s_tablet {\n    font-size: 1.8rem;\n  }\n}\n\n@mixin auth-subheading {\n  @include Inter;\n  line-height: 1.875rem;\n  font-weight: 400;\n  font-size: 1rem;\n  @include s_tablet {\n    font-size: 0.9rem;\n  }\n}\n@mixin validation-text {\n  color: #ff0000;\n  font-size: 0.875rem;\n}\n\n@mixin input-placeholder {\n  &.placeholder {\n    @content;\n  }\n  &:-moz-placeholder {\n    @content;\n  }\n  &::-moz-placeholder {\n    @content;\n  }\n  &:-ms-input-placeholder {\n    @content;\n  }\n  &::-webkit-input-placeholder {\n    @content;\n  }\n}\n\n@mixin respond-to($max-width) {\n  @media (max-width: $max-width) {\n    @content;\n  }\n}\n@mixin respond-to-min($max-width) {\n  @media (min-width: $max-width) {\n    @content;\n  }\n}\n\n@mixin respond-to-height($max-height) {\n  @media (max-height: $max-height) {\n    @content;\n  }\n}\n\n@mixin larger_desktop {\n  @media (min-width: 1920px) {\n    @content;\n  }\n}\n@mixin l_desktop {\n  @media (min-width: 1536px) {\n    @content;\n  }\n}\n\n@mixin sm_desktop {\n  @media (max-width: 1350px) {\n    @content;\n  }\n}\n\n@mixin m_desktop {\n  @media (max-width: 1199px) {\n    @content;\n  }\n}\n\n@mixin s_desktop {\n  @media (max-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin l_tablet {\n  @media (max-width: 991px) {\n    @content;\n  }\n}\n\n@mixin m_tablet {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm_tablet {\n  @media (min-width: 601px) and (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin s_tablet {\n  @media (max-width: 550px) {\n    @content;\n  }\n}\n@mixin l_mobile {\n  @media (max-width: 425px) {\n    @content;\n  }\n}\n@mixin m_mobile {\n  @media (max-width: 375px) {\n    @content;\n  }\n}\n@mixin s_mobile {\n  @media (max-width: 350px) {\n    @content;\n  }\n}\n@mixin xs_mobile {\n  @media (max-width: 300px) {\n    @content;\n  }\n}\n@mixin safari_specific_style {\n  @supports (-webkit-touch-callout: none) {\n    @content;\n  }\n}\n@mixin hide_scrollbar {\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  & {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n}\n\n@mixin underline_animation {\n  overflow: hidden;\n  background: linear-gradient(currentColor 0 0) 0 100% / var(--d, 0) 1px\n    no-repeat;\n  transition: 0.5s;\n  &:hover {\n    --d: 100%;\n  }\n}\n\n@mixin bounceInRight($duration: 0.5s) {\n  @-webkit-keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  @keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n}\n\n@mixin bounceOutRight($duration: 0.5s) {\n  @-webkit-keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      -webkit-transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n  }\n\n  @keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      transform: translateX(2000px);\n    }\n  }\n\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@mixin remove_userTapColor {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n@mixin ellipsis($line: 4) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: $line; /* Set the number of lines to be shown */\n  -webkit-box-orient: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
